import { render, staticRenderFns } from "./DocumentProducts.vue?vue&type=template&id=638ef2f2&scoped=true&"
import script from "./DocumentProducts.vue?vue&type=script&lang=js&"
export * from "./DocumentProducts.vue?vue&type=script&lang=js&"
import style0 from "./DocumentProducts.vue?vue&type=style&index=0&id=638ef2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ef2f2",
  null
  
)

export default component.exports